export default __webpack_public_path__ + "static/media/docker.d0ba50e8.png";